export default __webpack_public_path__ + "36a93cf260e7b41c87da06b3901928ac.svg";